import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
import Image from './Image';

Images.propTypes = {
  images: PropTypes.shape({ data: PropTypes.array }),
  className: PropTypes.string,
  imageHeight: PropTypes.number
};

export default function Images(props) {
  const { images, className, imageHeight } = props;

  const [galleryId] = useState(`g-${crypto.randomUUID()}`);

  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: `#${galleryId}`,
      children: 'a',
      // pswpModule: () => import('photoswipe')
      pswpModule: PhotoSwipe
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, []);

  return (
    <div id={galleryId} className={className}>
      {images.data.map(function(image, index) {
        return (
          <Image
            key={index}
            image={image}
            imageHeight={imageHeight}
          />
        );
      })}
    </div>
  );
};
